import React from 'react';
import PropTypes from 'prop-types';

const FooterText = (props) => (
	<React.Fragment>
		(C) { props.year } All Rights Reserved for Specular {' '}
		<a
			href="https://spclr.com"
			target="_blank"
			rel="noopener noreferrer"
			className="sidebar__link"
		>
			spclr.com
		</a>
	</React.Fragment>
)
FooterText.propTypes = {
    year: PropTypes.node,
	name: PropTypes.node,
	desc: PropTypes.node,
};
FooterText.defaultProps = {
    year: new Date().getFullYear()
};

export { FooterText };
